import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import {DocumentModel} from "@app/common/models/document.model";

@Component({
  selector: 'document-edit',
  templateUrl: './document-edit.component.html',
})
export class DocumentEditComponent implements OnInit {

  // model
  document: DocumentModel;
  canEdit;

  constructor(
    private dialogConfig: DialogConfig,
    public dialogComponent: DialogRef
  ) {
    this.onUpdate = this.onUpdate.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  ngOnInit() {
    this.document = (<DialogConfigData>this.dialogConfig.data).document;
    this.canEdit = (<DialogConfigData>this.dialogConfig.data).canEdit;
  }

  isValid() {
    return true;
  }

  onUpdate() {
    this.dialogComponent.close(this.document);
  }

  onCancel() {
    this.dialogComponent.close(false);
  }
}
